import { CurrencyInput, Fieldset, Skeleton, Table, Tooltip } from '@fourthwall/components';
import dayjs from 'dayjs';
import React from 'react';
import { isPaidTier } from '../../../../utils';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
import { getExchangeRate } from '../../utils';
import * as S from './styled';
export const CurrenciesTable = () => {
    const { tier, form, isPriceRatesLoading, priceRates, enabledCurrencies } = useTierContext();
    const getTableData = () => {
        if (!enabledCurrencies)
            return [];
        if (tier && !('pricesAutomaticallyConverted' in tier))
            return [];
        return enabledCurrencies.map((currency) => {
            const getSuggestion = () => {
                if (!form.values.price)
                    return undefined;
                if (isPriceRatesLoading)
                    return React.createElement(Skeleton.Shape, { height: 21, width: 140 });
                if (!priceRates)
                    return React.createElement(S.Error, null, "We couldn't load exchange rates.");
                return `${form.values.price} USD = ${getExchangeRate(currency, priceRates)} ${currency}`;
            };
            const getDisabled = () => {
                if (!tier)
                    return false;
                if (!isPaidTier(tier))
                    return false;
                return tier.variants.monthly.amounts[currency.toLowerCase()].locked;
            };
            return {
                currency,
                disabled: getDisabled(),
                suggestion: getSuggestion(),
            };
        });
    };
    return (React.createElement(Fieldset.Row, { inner: true },
        React.createElement(Fieldset.Item, null,
            React.createElement(Table, { data: getTableData(), emptyMessage: "You haven't enabled any currencies yet.", headers: [
                    {
                        id: 'price',
                        label: 'Price per month',
                        render: ({ currency, disabled }) => {
                            if (disabled) {
                                return (React.createElement(Tooltip, { placement: "top", reference: React.createElement(S.InputContainer, null,
                                        React.createElement(CurrencyInput, { label: currency, size: "small", prepend: currency, disabled: true, ...form.getFieldProps(`${FormFields.currencies}.${currency.toLowerCase()}`) })) }, "Tier price in this currency cannot be changed when there are active members."));
                            }
                            return (React.createElement(S.InputContainer, null,
                                React.createElement(CurrencyInput, { label: currency, size: "small", prepend: currency, disabled: disabled, max: currency === 'JPY' ? 999999999 : 99999, ...form.getFieldProps(`${FormFields.currencies}.${currency.toLowerCase()}`) })));
                        },
                        width: 2,
                    },
                    {
                        id: 'suggestion',
                        label: `Suggestion based on ${dayjs().format('MMM D, YYYY')} exchange rate`,
                        render: ({ suggestion }) => React.createElement(S.Suggestion, null, suggestion),
                        width: 5,
                    },
                ], minWidth: 0, compact: true }))));
};
